import * as S from "./ContentBox.style";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow_right.svg";

interface ContentBoxProps {
  mainTitle?: React.ReactNode;
  title?: React.ReactNode;
  text?: string;
  total?: number;
  sectionLink?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  subtitle?: string;
  padding?: boolean;
}

export const ContentBox = ({
  mainTitle,
  title,
  text,
  total,
  sectionLink,
  onClick,
  children,
  subtitle,
  padding,
}: ContentBoxProps) => {
  return (
    <S.ContentBox $text={text ? true : false} $padding={padding ? true : false}>
      {mainTitle && mainTitle}
      {title && (
        <S.ContentTitBox>
          <S.ContentTit>
            {subtitle && <S.subtitle>{subtitle}</S.subtitle>}
            <h4>
              {title}
              {total && <S.ContentTotal>{total}건</S.ContentTotal>}
            </h4>
            {text && <p>{text}</p>}
          </S.ContentTit>

          {sectionLink ? (
            <S.ContentLink href={sectionLink}>
              전체보기
              <IconArrow width={22} height={22} />
            </S.ContentLink>
          ) : onClick ? (
            <S.ContentLinkDiv onClick={onClick}>
              전체보기
              <IconArrow width={22} height={22} />
            </S.ContentLinkDiv>
          ) : (
            <></>
          )}
        </S.ContentTitBox>
      )}

      <S.Content>{children}</S.Content>
      {/* 
      {showWritingBox && (
        <S.WritingBox>
          <p>육아상담이 필요하신가요?</p>
          {writingButton && writingButton}
        </S.WritingBox>
      )} */}
    </S.ContentBox>
  );
};
